{
  "#LAGERKORREKTUR": {
    "APP": "Lagerkorrektur",
    "APP_DESC": "Mengenkorrektur (einseitige Lagerbuchung)",
    "TITLE": "Lagerkorrektur",
    "PAGES": {
      "LAGERPLATZ_SCANNEN": {
        "TITLE": "Lagerplatz scannen",
        "DESCRIPTION": "Bitte scannen Sie einen Lagerplatz-Barcode"
      },
      "ARTIKEL_AUSWAHL": {
        "TITLE": "Artikel auswählen",
        "DESCRIPTION": "Bitte Artikel auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter",
        "NO_ITEMS": "Auf diesem Lagerplatz sind keine Artikel vorhanden"
      },
      "MENGEN_AUSWAHL": {
        "TITLE": "Menge auswählen",
        "DESCRIPTION": "Bitte Menge auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter"
      },
      "LAGERSYMBOL_AUSWAHL": {
        "TITLE": "Lagersymbol auswählen",
        "DESCRIPTION": "Bitte Lagersymbol auswählen",
        "LAGERPLATZ": "Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SYMBOL": "Lagersymbol",
        "SUBMIT": "Weiter"
      }
    },
    "MESSAGES": {
      "SUCCESS": {
        "KORREKTUR": "Der Artikel am Lagerplatz wurde korrigiert"
      }
    }
  }
}
